import api from "api/flexapi";

export const updateWellness = "updateWellness";
export const updateBenefits = "updateBenefits";

export const REQUEST_ACCOUNT_WALLET = "REQUEST_ACCOUNT_WALLET";
export const SUCCESS_ACCOUNT_WALLET = "SUCCESS_ACCOUNT_WALLET";
export const FAILURE_ACCOUNT_WALLET = "FAILURE_ACCOUNT_WALLET";

export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";

// Call API to update cart data
export function updateWellnessItem(itemId, newQuantity, itemPrice) {
  // Return thunk middleware
  return dispatch => {
    dispatch({
      type: updateWellness,
      payload: { item: itemId, quantity: newQuantity, price: itemPrice },
    });
  };
}

export function updateBenefitsItem(benefits, plan) {
  // Return thunk middleware
  return dispatch => {
    dispatch({
      type: updateBenefits,
      payload: { benefitList: benefits, plan },
    });
  };
}

// TODO: duplicated (claimAction)
const removeUndefinedObjectValue = data => {
  Object.keys(data).forEach(
    key =>
      (data[key] === undefined ||
        data[key] === null ||
        (key === "selectedDelegator" && data[key] === "Myself")) &&
      delete data[key]
  );

  return data;
};

export const loadAccountWallet = (
  planYear,
  effectiveDate,
  includingHidden = false,
  selectedDelegator
) => dispatch => {
  const meta = { planYear, effectiveDate, includingHidden };
  const data = {
    ...(effectiveDate !== null ? { effectiveDate } : {}),
    ...(includingHidden !== null ? { includingHidden } : {}),
    selectedDelegator,
  };

  // remove object with value undefined or null
  removeUndefinedObjectValue(data);

  dispatch({ type: REQUEST_ACCOUNT_WALLET, meta });
  api
    .getAccountEnrolmentSummary(data)
    .then(response => {
      dispatch({
        type: SUCCESS_ACCOUNT_WALLET,
        meta,
        payload: response.body,
      });
    })
    .catch(err =>
      dispatch({
        type: FAILURE_ACCOUNT_WALLET,
        meta,
        payload: err.response ? err.response.body : err,
      })
    );
};



// WEBPACK FOOTER //
// ./actions/cartActions.jsx